<template>
<div>
   aaa
</div>


</template>
<script>
export default{
    name:"PerFormance",
    data(){
        return{

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/PerFormance/PerFormance.vue